import {
  LOAD_CALENDAR_EVENTS,
  SHOW_DAILY_EVENT,
  HIDE_DETAIL_EVENT,
  SHOW_DETAIL_EVENT,
  GO_TO_TODAY
} from '../constants/actionTypes/events';

export const initialState = {
  events: [],
  eventsByDay: {},
  showDayDetail: false,
  showEventDetail: false,
  dayDetail: '',
  detail: null,
  selectedDate: new Date(),
  showNavigators: true
};

export default (state = initialState, action) => {
  const { type, events, eventsByDay, dayDetail, detail, selectedDate } = action;

  switch (type) {
    case GO_TO_TODAY:
      return {
        ...state,
        selectedDate,
        dayDetail
      };
    case LOAD_CALENDAR_EVENTS:
      return {
        ...state,
        events,
        eventsByDay,
        selectedDate,
        dayDetail,
        showDayDetail: true
      };
    case SHOW_DAILY_EVENT:
      return {
        ...state,
        showDayDetail: true,
        showEventDetail: false,
        selectedDate,
        dayDetail
      };
    case HIDE_DETAIL_EVENT:
      return {
        ...state,
        showEventDetail: false,
        showDayDetail: true,
        detail: null,
        showNavigators: true
      };
    case SHOW_DETAIL_EVENT:
      return {
        ...state,
        showEventDetail: true,
        showDayDetail: false,
        showNavigators: false,
        detail
      };
    default:
      return state;
  }
};
